/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkRemoveBrandsRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {BulkRemoveBrandsResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const bulkRemoveBrands = (request:BulkRemoveBrandsRequest, options?: CashRequestOptions) => post<BulkRemoveBrandsRequest, BulkRemoveBrandsResponse>("/2.0/cash/bulk-remove-brands", request, {...options, rejectOnError: true })